import { ChevronRight, Layout, Zap, Star, Image as ImageIcon, AlignLeft, FolderOpen } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { CatalogComponent } from '@/types/components'

export const CATEGORY_META: Record<string, { icon: LucideIcon; cardClass: string; iconClass: string }> = {
  'Hero':        { icon: Layout,    cardClass: 'border-blue-200   bg-blue-50/40   hover:bg-blue-50',   iconClass: 'bg-blue-100   text-blue-600' },
  'CTA':         { icon: Zap,       cardClass: 'border-purple-200 bg-purple-50/40 hover:bg-purple-50', iconClass: 'bg-purple-100 text-purple-600' },
  'Konten Idol': { icon: Star,      cardClass: 'border-pink-200   bg-pink-50/40   hover:bg-pink-50',   iconClass: 'bg-pink-100   text-pink-600' },
  'Media':       { icon: ImageIcon, cardClass: 'border-green-200  bg-green-50/40  hover:bg-green-50',  iconClass: 'bg-green-100  text-green-600' },
  'Teks':        { icon: AlignLeft, cardClass: 'border-amber-200  bg-amber-50/40  hover:bg-amber-50',  iconClass: 'bg-amber-100  text-amber-600' },
}

export function CategoryFolderCard({
  category,
  components,
  onClick,
}: {
  category: string
  components: CatalogComponent[]
  onClick: () => void
}) {
  const meta = CATEGORY_META[category] ?? {
    icon: FolderOpen,
    cardClass: 'border-border bg-muted/20 hover:bg-muted/40',
    iconClass: 'bg-muted text-muted-foreground',
  }
  const Icon = meta.icon
  const displayed = components.slice(0, 5)
  const rest = components.length - displayed.length

  return (
    <button
      onClick={onClick}
      className={`group w-full text-left rounded-xl border p-4 transition-all duration-150 hover:shadow-md ${meta.cardClass}`}
    >
      <div className="flex items-center gap-3 mb-3">
        <div className={`shrink-0 rounded-lg p-2 ${meta.iconClass}`}>
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-sm">{category}</h3>
          <p className="text-xs text-muted-foreground">{components.length} komponen</p>
        </div>
        <ChevronRight className="shrink-0 h-4 w-4 text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
      </div>
      <div className="flex flex-wrap gap-1.5">
        {displayed.map((c) => (
          <span
            key={c.component_key}
            className="text-[11px] rounded bg-background/70 border border-border/60 px-1.5 py-0.5 text-muted-foreground"
          >
            {c.label}
          </span>
        ))}
        {rest > 0 && (
          <span className="text-[11px] rounded bg-background/70 border border-border/60 px-1.5 py-0.5 text-muted-foreground opacity-70">
            +{rest} lainnya
          </span>
        )}
      </div>
    </button>
  )
}
